import { createContext } from 'react';
export const EditorStateContext = /*#__PURE__*/createContext({});
EditorStateContext.displayName = 'EditorStateContext';